export default "/corgi/pageapps/purchase/_next/static/media/green-checkmark.99f8854f.svg";